import { useApp } from "../../../hooks/useApp"

export const BuilderGallery = () => {
  const { mainProduct } = useApp()

  const galleryImageUrls = mainProduct.gallery

  if (galleryImageUrls.length === 0) {
    return null
  }

  return (
    <ul className="builder-gallery pt-5 xl:pt-0 xl:grid xl:grid-cols-2 xl:gap-5 xl:px-5">
      {galleryImageUrls.map((url, index) => (
        <li key={`${mainProduct.id}-${index}`} className="builder-gallery__item">
          <img
            className="rounded-sm w-full"
            src={url}
            alt={mainProduct.title}
          />
        </li>
      ))}
    </ul>
  )
}
